import { CheckCircle } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type FinishProps = {
  robby?: () => void;
};

const Finish: React.FC<FinishProps> = ({ robby }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Grid item>
        <CheckCircle style={{ fontSize: "128px", color: "green" }} />
      </Grid>
      <Grid item>
        <Typography variant="h4">{t("finishConfiguration")}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t("finishConfigurationDescription")}</Typography>
      </Grid>
      <Grid
        xs={8}
        container
        item
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={8} xl={6}>
          <Grid
            container
            spacing={2}
            display="flex"
            alignItems="flex-start"
            justifyContent="center"
          >
            <Grid item>
              <Button
                size="large"
                variant="contained"
                onClick={() => navigate(0)}
              >
                {t("otherDeviceConfiguration")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Finish;
